import { gql } from '@apollo/client';

export const CREATE_ALLEGATI = ({
  canvasId,
  defuntoId = '',
  filename,
  url,
  mimeType,
  size_bytes,
  isImageEnhancement = false,
  enhancementRawImage = undefined,
  isMagicEraser = false,
  magicEraserRawImage = undefined,
  magicEraserMask = undefined,
  isChangeClothes = false,
  changeClothesRawImage = undefined,
  changeClothesMask = undefined,
  changeClothesItem = undefined,
  isSmile = false,
  smileRawImage = undefined,
  isColorizeBw = false,
  colorizeBwRawImage = undefined,
  isExpand = false,
  expandRawImage = undefined,
  isRemovebg = false,
  isBlurBg = false,
  removebgRawImage = undefined,
  isAutoColor = false,
  rawImage = undefined,
  isAiEdit = false,
  aiEditPrompt = undefined,
  aiEditRawImage = undefined,
}) => gql`
  mutation createAnAllegati {
    createAllegati(
      input: {
        fields: {
          mimeType: "${mimeType}",
          editor_canvas_pointer: { link: "${canvasId}" }
          defunto_pointer: { link: "${defuntoId}" }
          size_bytes: ${size_bytes}
          isImageEnhancement: ${isImageEnhancement}
          isMagicEraser: ${isMagicEraser}
          isChangeClothes: ${isChangeClothes}
          isSmile: ${isSmile}
          isColorizeBw: ${isColorizeBw}
          isExpand: ${isExpand}
          isRemovebg: ${isRemovebg}
          isBlurBg: ${isBlurBg}
          isAutoColor: ${isAutoColor}
          isAiEdit: ${isAiEdit}
          ${aiEditPrompt ? `aiEditPrompt: "${aiEditPrompt}"` : ''}
          ${aiEditRawImage ? `aiEditRawImage: "${aiEditRawImage}"` : ''}
          ${rawImage ? `rawImage: "${rawImage}"` : ''}
          ${
            enhancementRawImage
              ? `enhancementRawImage: "${enhancementRawImage}"`
              : ''
          }
          ${
            magicEraserRawImage
              ? `magicEraserRawImage: "${magicEraserRawImage}"`
              : ''
          }
          ${magicEraserMask ? `magicEraserMask: "${magicEraserMask}"` : ''}
          ${
            changeClothesRawImage
              ? `changeClothesRawImage: "${changeClothesRawImage}"`
              : ''
          }
          ${
            changeClothesMask ? `changeClothesMask: "${changeClothesMask}"` : ''
          }
          ${
            changeClothesItem ? `changeClothesItem: "${changeClothesItem}"` : ''
          }
          ${smileRawImage ? `smileRawImage: "${smileRawImage}"` : ''}
          ${
            colorizeBwRawImage
              ? `colorizeBwRawImage: "${colorizeBwRawImage}"`
              : ''
          }
          ${isExpand ? `expandRawImage: "${expandRawImage}"` : ''} 
          ${removebgRawImage ? `removebgRawImage: "${removebgRawImage}"` : ''}
          allegato: {
            file: {
              __type: "File"
              name: "${filename}"
              url: "${url}"
            }
          }
        }
      }
    ) {
      allegati {
        nome
      }
    }
  }
`;
